"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The Menu model module.
 * @module model/Menu
 * @version 0.2.0
 */
var Menu = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>Menu</code>.
   * @alias module:model/Menu
   */
  function Menu() {
    _classCallCheck(this, Menu);

    Menu.initialize(this);
  }
  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */


  _createClass(Menu, null, [{
    key: "initialize",
    value: function initialize(obj) {}
    /**
     * Constructs a <code>Menu</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Menu} obj Optional instance to populate.
     * @return {module:model/Menu} The populated <code>Menu</code> instance.
     */

  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new Menu();

        if (data.hasOwnProperty('id')) {
          obj['id'] = _ApiClient["default"].convertToType(data['id'], 'Number');
        }

        if (data.hasOwnProperty('menu_text')) {
          obj['menu_text'] = _ApiClient["default"].convertToType(data['menu_text'], 'String');
        }

        if (data.hasOwnProperty('menu_description')) {
          obj['menu_description'] = _ApiClient["default"].convertToType(data['menu_description'], 'String');
        }

        if (data.hasOwnProperty('i18n_menu_key')) {
          obj['i18n_menu_key'] = _ApiClient["default"].convertToType(data['i18n_menu_key'], 'String');
        }

        if (data.hasOwnProperty('i18n_description_key')) {
          obj['i18n_description_key'] = _ApiClient["default"].convertToType(data['i18n_description_key'], 'String');
        }

        if (data.hasOwnProperty('target_url')) {
          obj['target_url'] = _ApiClient["default"].convertToType(data['target_url'], 'String');
        }

        if (data.hasOwnProperty('window_target')) {
          obj['window_target'] = _ApiClient["default"].convertToType(data['window_target'], 'String');
        }

        if (data.hasOwnProperty('desktop_view_icon')) {
          obj['desktop_view_icon'] = _ApiClient["default"].convertToType(data['desktop_view_icon'], 'String');
        }

        if (data.hasOwnProperty('mobile_view_icon')) {
          obj['mobile_view_icon'] = _ApiClient["default"].convertToType(data['mobile_view_icon'], 'String');
        }

        if (data.hasOwnProperty('position')) {
          obj['position'] = _ApiClient["default"].convertToType(data['position'], 'Number');
        }

        if (data.hasOwnProperty('render_in_user_menu')) {
          obj['render_in_user_menu'] = _ApiClient["default"].convertToType(data['render_in_user_menu'], 'Boolean');
        }

        if (data.hasOwnProperty('subMenus')) {
          obj['subMenus'] = _ApiClient["default"].convertToType(data['subMenus'], [Menu]);
        }
      }

      return obj;
    }
  }]);

  return Menu;
}();
/**
 * @member {Number} id
 */


Menu.prototype['id'] = undefined;
/**
 * @member {String} menu_text
 */

Menu.prototype['menu_text'] = undefined;
/**
 * @member {String} menu_description
 */

Menu.prototype['menu_description'] = undefined;
/**
 * @member {String} i18n_menu_key
 */

Menu.prototype['i18n_menu_key'] = undefined;
/**
 * @member {String} i18n_description_key
 */

Menu.prototype['i18n_description_key'] = undefined;
/**
 * @member {String} target_url
 */

Menu.prototype['target_url'] = undefined;
/**
 * @member {String} window_target
 */

Menu.prototype['window_target'] = undefined;
/**
 * @member {String} desktop_view_icon
 */

Menu.prototype['desktop_view_icon'] = undefined;
/**
 * @member {String} mobile_view_icon
 */

Menu.prototype['mobile_view_icon'] = undefined;
/**
 * @member {Number} position
 */

Menu.prototype['position'] = undefined;
/**
 * @member {Boolean} render_in_user_menu
 */

Menu.prototype['render_in_user_menu'] = undefined;
/**
 * @member {Array.<module:model/Menu>} subMenus
 */

Menu.prototype['subMenus'] = undefined;
var _default = Menu;
exports["default"] = _default;